import Cookies, { CookieAttributes } from 'js-cookie';

export const accessTokenCookieKey = (prefix?: string) => `${prefix ?? ''}access_token`;
export const refreshTokenCookieKey = (prefix?: string) => `${prefix ?? ''}refresh_token`;

export const defaultProps: CookieAttributes = {
	path: '/',
	secure: true,
	expires: 365,
};

export function setCookie(key: string, value: string, props: CookieAttributes = defaultProps) {
	console.debug('setCookie', key, value, props);
	Cookies.set(key, value, props);
}

export function getCookie(key: string) {
	return Cookies.get(key);
}

export function removeCookie(key: string, props: CookieAttributes = defaultProps) {
	Cookies.remove(key, props);
}

export const createAuthUtils = (domain: string, prefix?: string) => ({
	getAccessTokenCookie: () => getCookie(accessTokenCookieKey(prefix)),
	getRefreshTokenCookie: () => getCookie(refreshTokenCookieKey(prefix)),
	setAccessTokenCookie: (value: string) => setCookie(accessTokenCookieKey(prefix), value, { ...defaultProps, domain }),
	setRefreshTokenCookie: (value: string) => setCookie(refreshTokenCookieKey(prefix), value, { ...defaultProps, domain }),
	removeAccessTokenCookie: () => removeCookie(accessTokenCookieKey(prefix), { ...defaultProps, domain }),
	removeRefreshTokenCookie: () => removeCookie(refreshTokenCookieKey(prefix), { ...defaultProps, domain }),
});
